/* StylinArts – Colette v2.1 (Luxury + Futuristic, triple-star launcher) */
(function () {
  if (window.__SA_V2_WIDGET__) return;
  window.__SA_V2_WIDGET__ = true;

  var OPTS = Object.assign({
    label: 'Colette',
    hintLimit: 8,
    safeBottom: 84,
    endpoint: 'https://www.stylinarts.com/_ai/chat'
  }, (window.SA_STYLIST_OPTS || {}));

  // endpoints
  var ORIGIN; try { ORIGIN = new URL(OPTS.endpoint).origin; } catch(e){ ORIGIN = 'https://www.stylinarts.com'; }
  var API_CHAT = OPTS.endpoint;
  var API_IMG  = ORIGIN + '/_ai/image_search';

  /* ==================== LUXURY + FUTURE STYLES ==================== */
  var CSS = `
  :root{
    --sa-safe: ${Number(OPTS.safeBottom)}px;

    /* star palette */
    --sa-star: #EBDDC7;          /* champagne */
    --sa-star-dark: #C6B089;

    /* glass & rings */
    --sa-ring: rgba(255,255,255,.06);
    --sa-hairline: rgba(0,0,0,.08);

    /* shadows */
    --sa-shadow: 0 10px 28px rgba(0,0,0,.14);
    --sa-shadow-hover: 0 14px 36px rgba(0,0,0,.18);

    /* sizes for three stars (tweak freely) */
    --sa-star-a: 46px;
    --sa-star-b: 33px;
    --sa-star-c: 38px;
  }

  /* -------- Launcher: transparent glass with iridescent ring -------- */
  .sa-pill{
    position:fixed; z-index:2147483000; right:clamp(22px,3vw,32px);
    bottom:calc(env(safe-area-inset-bottom,0px) + var(--sa-safe));
    display:inline-flex; align-items:center; gap:10px;
    padding:12px 18px; min-height:46px; border-radius:9999px;
    background:transparent; color:#111;
    font:600 14px/1.1 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    letter-spacing:.01em; cursor:pointer; user-select:none; touch-action:none;
    box-shadow: var(--sa-shadow);
    border:none; isolation:isolate; transform:translateZ(0);
  }
  /* Blur film */
  .sa-pill::before{
    content:""; position:absolute; inset:0; border-radius:inherit;
    background: var(--sa-ring);
    backdrop-filter: blur(12px) saturate(1.05);
    -webkit-backdrop-filter: blur(12px) saturate(1.05);
    pointer-events:none; z-index:-1;
  }
  /* Iridescent ring (very subtle, future) */
  .sa-pill::after{
    content:""; position:absolute; inset:0; border-radius:inherit;
    background: conic-gradient(from 210deg,
      rgba(255,255,255,.35), rgba(255,255,255,0) 18%,
      rgba(0,0,0,.10) 32%, rgba(255,255,255,0) 54%,
      rgba(255,255,255,.25) 70%, rgba(0,0,0,.08) 86%, rgba(255,255,255,.35));
    mask: radial-gradient(closest-side, transparent 92%, #000 93% 100%);
    opacity:.45; pointer-events:none;
  }
  @media (prefers-reduced-motion:no-preference){
    .sa-pill::after{ animation: saSweep 4s linear infinite; }
    @keyframes saSweep{ to{ transform: rotate(360deg); } }
  }

  /* ---------- Three-star cluster (sizes/angles/offsets all different) ---------- */
  .sa-stars{ position:relative; width:0; height:0; }
  .sa-star{
    position:absolute; display:inline-flex; align-items:center; justify-content:center;
    color:var(--sa-star); filter: drop-shadow(0 2px 6px rgba(0,0,0,.06));
  }
  /* Large star slightly overlapping the label, low and left */
  .sa-star.s1{ width:var(--sa-star-a); height:var(--sa-star-a); left:-10px; top:-8px; transform: rotate(-8deg); }
  /* Tiny star high and forward */
  .sa-star.s2{ width:var(--sa-star-b); height:var(--sa-star-b); left:10px; top:-22px; transform: rotate(6deg); opacity:.95; }
  /* Mid star a bit lower, pushed forward */
  .sa-star.s3{ width:var(--sa-star-c); height:var(--sa-star-c); left:24px; top:0px; transform: rotate(15deg); opacity:.9; }

  .sa-star svg{ width:100%; height:100%; display:block; }

  .sa-pill:hover{ box-shadow: var(--sa-shadow-hover); }
  .sa-pill:active{ transform: translateZ(0) scale(.99); }
  .sa-pill:focus-visible{
    outline:2px solid rgba(0,0,0,.75); outline-offset:2px;
    box-shadow: 0 0 0 4px rgba(0,0,0,.12), var(--sa-shadow);
  }

  .sa-label{ padding-left:40px; } /* extra so the stars can intrude without touching text */

  @media (prefers-color-scheme: dark){
    .sa-pill{ color:#F6F6F4; }
    .sa-pill::before{
      background: rgba(25,25,25,.35);
    }
    .sa-star{ color:var(--sa-star-dark); }
  }

  /* ---------------- Panel (glass, future header) ---------------- */
  .sa-panel{
    position:fixed; z-index:2147482999; right:clamp(22px,3vw,32px);
    bottom:calc(env(safe-area-inset-bottom,0px) + var(--sa-safe) + 64px);
    width:min(420px, 92vw);
    background:rgba(255,255,255,.96);
    backdrop-filter: blur(8px) saturate(1.05);
    -webkit-backdrop-filter: blur(8px) saturate(1.05);
    border:1px solid rgba(0,0,0,.12); border-radius:18px; overflow:hidden;
    box-shadow:0 22px 60px rgba(0,0,0,.28);
    font:14px/1.45 ui-sans-serif, system-ui, -apple-system, Inter, "Helvetica Neue", Arial, sans-serif;
    display:none;
  }
  .sa-head{
    position:relative; display:flex; align-items:center; gap:8px; padding:12px 14px;
    background:
      linear-gradient(180deg, rgba(255,255,255,.66), rgba(255,255,255,.40));
    border-bottom:1px solid rgba(0,0,0,.06);
  }
  /* subtle light streak */
  .sa-head::after{
    content:""; position:absolute; left:10%; right:10%; top:0; height:2px; border-radius:2px;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
    opacity:.8;
  }
  .sa-head strong{ font-weight:700; letter-spacing:.01em }
  .sa-actions{ margin-left:auto; display:flex; gap:6px }
  .sa-head button{
    border:1px solid rgba(0,0,0,.08); background:#fff; border-radius:10px; height:30px; padding:0 10px; font:600 12px/1 ui-sans-serif; cursor:pointer;
  }

  .sa-body{ max-height:min(70vh,560px); overflow:auto; padding:12px 14px; }
  .sa-row{ margin:8px 0; }
  .sa-msg{ background:#fff; border:1px solid rgba(0,0,0,.06); border-radius:12px; padding:10px 12px }

  /* Bullet alignment & spacing (strict left) */
  .sa-msg ul{ margin:8px 0 8px 18px; padding-left:18px; list-style: disc; list-style-position: outside; }
  .sa-msg li{ margin:4px 0; }

  /* ---------------- Try chips: thinner, tighter ---------------- */
  .sa-row.sa-try-title{ font-size:11.5px; color:#666; margin-top:0 }
  .sa-row.sa-try{ display:flex; flex-wrap:wrap; gap:6px 8px }
  .sa-row.sa-try button{
    border:1px solid #E6E6E6; background:rgba(255,255,255,.95) !important; color:#111 !important;
    border-radius:9999px; padding:5px 9px; font:500 11.5px/1 ui-sans-serif;
    box-shadow: 0 1px 2px rgba(0,0,0,.03);
  }

  /* ---------------- Cards ---------------- */
  .sa-suggest{ display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-top:8px }
  .sa-card{ border:1px solid #eee; border-radius:12px; padding:8px; display:flex; gap:8px; text-decoration:none; color:inherit; background:#fff }
  .sa-card img{ width:68px; height:68px; object-fit:cover; border-radius:10px; border:1px solid #eee }
  .sa-card .t{ font-weight:700; font-size:10.5px; line-height:1.25; max-height:2.6em; overflow:hidden }
  .sa-card .m{ font-size:11px; color:#666; margin-top:4px }

  /* ---------------- Input row + elegant Send ---------------- */
  .sa-input{ display:flex; gap:8px; border-top:1px solid rgba(0,0,0,.06); padding:12px 12px; background:rgba(255,255,255,.94) }
  .sa-input input{
    flex:1; height:44px; border:1px solid #e6e6e6; border-radius:12px; padding:0 12px;
    font:14px/44px ui-sans-serif; box-shadow: inset 0 1px 2px rgba(0,0,0,.03);
  }
  .sa-input button{
    height:44px; border:0; border-radius:9999px; padding:0 18px;
    font:600 14px ui-sans-serif; cursor:pointer; color:#fff;
    background:
      radial-gradient(120% 120% at 10% 0%, rgba(255,255,255,.14), transparent 40%),
      linear-gradient(135deg, #0F0F10, #1b1b1e);
    box-shadow:
      0 0 0 1px rgba(255,255,255,.08) inset,
      0 6px 18px rgba(0,0,0,.20),
      0 0 18px rgba(120,140,255,.10); /* soft AI-ish glow */
    transition: box-shadow .15s ease, transform .15s ease, background .15s ease;
  }
  .sa-input button:hover{
    box-shadow:
      0 0 0 1px rgba(255,255,255,.12) inset,
      0 10px 24px rgba(0,0,0,.24),
      0 0 22px rgba(120,140,255,.18);
    transform: translateY(-1px);
  }
  .sa-input button:active{ transform: translateY(0) }
  .sa-input button:focus-visible{
    outline:2px solid rgba(0,0,0,.75); outline-offset:2px;
  }
  `;

  var style = document.createElement('style');
  style.textContent = CSS; document.head.appendChild(style);

  // ---------- Helpers ----------
  function esc(s){return String(s||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
  function renderAI(text){
    text = String(text||'').replace(/\r\n/g,'\n');
    // Normalize inline bullets into list items
    text = text.replace(/\s+(•|-|\*)\s+/g, '\n• ');
    var lines = text.split('\n'), blocks=[], bullets=[];
    function flush(){ if(!bullets.length) return;
      blocks.push('<ul>'+bullets.map(b => '<li>'+esc(b.replace(/^(•|-|\*)\s+/,'').trim())+'</li>').join('')+'</ul>'); bullets=[]; }
    for (var i=0;i<lines.length;i++){
      var ln = lines[i].trim();
      if (!ln){ flush(); continue; }
      if (/^(•|-|\*)\s+/.test(ln)){ bullets.push(ln); continue; }
      flush(); blocks.push('<p>'+esc(ln)+'</p>');
    }
    flush(); return blocks.join('');
  }

  function mount(){
    // pill
    var pill = document.createElement('button');
    pill.type='button'; pill.className='sa-pill';
    pill.innerHTML='<span class="sa-stars">'+
                     '<span class="sa-star s1" aria-hidden="true"></span>'+
                     '<span class="sa-star s2" aria-hidden="true"></span>'+
                     '<span class="sa-star s3" aria-hidden="true"></span>'+
                   '</span>'+
                   '<span class="sa-label"></span>';
    document.body.appendChild(pill);
    pill.querySelector('.sa-label').textContent = OPTS.label || 'Colette';

    // inject SVG into each star (crisp 5-point, uses currentColor)
    pill.querySelectorAll('.sa-star').forEach(function(el){
      el.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path fill="currentColor" d="M12 2.2l2.14 6.59h6.93l-5.6 4.07 2.14 6.59L12 15.63 6.39 19.45l2.14-6.59-5.6-4.07h6.93L12 2.2z"/>' +
        '</svg>';
    });

    // panel
    var panel = document.createElement('div');
    panel.className='sa-panel'; panel.style.display='none';
    panel.innerHTML=[
      '<div class="sa-head">',
        '<strong>StylinArts AI</strong>',
        '<div class="sa-actions"><button type="button" id="saSimilarBtn" title="Find similar">Similar</button></div>',
      '</div>',
      '<div class="sa-body" id="saBody"></div>',
      '<div class="sa-input">',
        '<input id="saInput" placeholder="Ask for a color, price, size, policy..."/>',
        '<button id="saSend">Send</button>',
      '</div>'
    ].join('');
    document.body.appendChild(panel);

    function bodyEl(){ return document.getElementById('saBody'); }
    function row(html){ var b=bodyEl(); b.insertAdjacentHTML('beforeend','<div class="sa-row sa-msg">'+html+'</div>'); b.scrollTop=b.scrollHeight; }

    function cards(hints){
      return (hints||[]).slice(0, Number(OPTS.hintLimit||8)).map(function(h){
        return '<a class="sa-card" href="'+(h.url||'#')+'">'+
                 (h.image?'<img loading="lazy" src="'+h.image+'" alt=""/>':'')+
                 '<div><div class="t">'+esc(h.label||'')+'</div>'+
                 '<div class="m">'+esc(h.price||'')+(h.available?' • In stock':'')+'</div></div>'+
               '</a>';
      }).join('');
    }

    // seed “Try”
    (function seed(){
      var b=bodyEl();
      var qs=['black lace bodysuit under $60','red satin set under $50','size guide','refund policy'];
      b.insertAdjacentHTML('beforeend','<div class="sa-row sa-try-title">Try:</div>');
      b.insertAdjacentHTML('beforeend',
        '<div class="sa-row sa-try">'+
          qs.map(function(q){return '<button type="button" data-q="'+esc(q)+'">'+esc(q)+'</button>';}).join('')+
        '</div>'
      );
      b.addEventListener('click', function(e){
        var q=e.target && e.target.getAttribute && e.target.getAttribute('data-q');
        if(q){ send(q); }
      });
    })();

    // show/hide panel
    function openPanel(){ panel.style.display='block'; var b=bodyEl(); setTimeout(function(){ b.scrollTop=b.scrollHeight; },0); }
    function closePanel(){ panel.style.display='none'; }
    pill.addEventListener('click', function(){ panel.style.display==='none' ? openPanel() : closePanel(); });

    // drag the pill
    (function(){
      var drag=false,ox=0,oy=0,raf=null;
      function clamp(v,min,max){return Math.max(min,Math.min(max,v));}
      function setPos(x,y){ pill.style.left=x+'px'; pill.style.top=y+'px'; pill.style.right=''; pill.style.bottom=''; }
      function down(cx,cy){ drag=true; var r=pill.getBoundingClientRect(); ox=cx-r.left; oy=cy-r.top;
        addEventListener('mousemove',move); addEventListener('mouseup',up);
        addEventListener('touchmove',tm,{passive:false}); addEventListener('touchend',up);
      }
      function q(cx,cy){
        if(raf) return; raf=requestAnimationFrame(function(){
          raf=null; var w=pill.offsetWidth,h=pill.offsetHeight;
          var bottomPx = 8 + Number(OPTS.safeBottom||84);
          var x=clamp(cx-ox,8,innerWidth-w-8), y=clamp(cy-oy,8,innerHeight-h-bottomPx);
          setPos(x,y);
        });
      }
      function move(e){ e.preventDefault(); q(e.clientX,e.clientY); }
      function tm(e){ if(!drag) return; e.preventDefault(); var t=e.touches[0]; q(t.clientX,t.clientY); }
      function up(){ drag=false; removeEventListener('mousemove',move); removeEventListener('mouseup',up); removeEventListener('touchmove',tm); removeEventListener('touchend',up); }
      pill.addEventListener('mousedown',e=>down(e.clientX,e.clientY));
      pill.addEventListener('touchstart',e=>{ if(e.touches&&e.touches[0]) down(e.touches[0].clientX,e.touches[0].clientY); },{passive:true});
    })();

    // hide Try when user starts typing (or after first send)
    var input = panel.querySelector('#saInput');
    function hideTry(){ bodyEl().querySelectorAll('.sa-try,.sa-try-title').forEach(n=>n.style.display='none'); }
    input.addEventListener('input', function(){ if (this.value.trim().length) hideTry(); });

    // context
    function pageCtx(){
      var p={page:'home'};
      try{
        var path=location.pathname;
        if(/\/products\//.test(path)){
          var t=(document.querySelector('h1')||{}).textContent||''; t=t.trim();
          var imgEl=document.querySelector('img[src*="cdn.shopify.com"], img[src*="/cdn/shop/"]');
          var imgSrc=imgEl? (imgEl.currentSrc||imgEl.src) : '';
          p.page='product'; p.product={title:t,image:imgSrc};
        }else if(/\/collections\//.test(path)){
          var tt=(document.querySelector('h1')||{}).textContent||''; tt=tt.trim();
          p.page='collection'; p.collection={title:tt,handle:path.split('/').pop()};
        }else if(/\/search/.test(path)){
          var q=new URL(location.href).searchParams.get('q')||''; p.page='search'; p.searchQuery=q;
        }else if(/\/cart/.test(path)){ p.page='cart'; }
      }catch(e){}
      return p;
    }
    var context = pageCtx();

    // sending
    var inFlight=false, lastTs=0;
    function guard(){ var now=Date.now(); if(inFlight || (now-lastTs)<400) return false; lastTs=now; return true; }

    async function send(qText){
      if (!guard()) return; inFlight=true;
      try{
        if (!qText) qText = (input && input.value || '').trim();
        if (input) input.value=''; if (!qText) return;
        hideTry();
        row('<em>…thinking</em>');
        const res = await fetch(API_CHAT,{
          method:'POST', headers:{'content-type':'application/json'},
          body: JSON.stringify({ message:qText, context:context, max_hints:Number(OPTS.hintLimit||8) })
        });
        const js = await res.json().catch(()=>({}));
        var b=bodyEl(); if (b.lastElementChild) b.lastElementChild.remove();
        if (js && js.text) row(renderAI(js.text));
        if (js && Array.isArray(js.hints) && js.hints.length){
          b.insertAdjacentHTML('beforeend','<div class="sa-suggest">'+cards(js.hints)+'</div>');
          b.scrollTop=b.scrollHeight;
        }
        if (js && js.error === 'budget_exceeded'){
          row('<span style="color:#b00">Daily AI budget reached. Please try again tomorrow.</span>');
        } else if (js && js.ok===false && js.error){
          row('<span style="color:#b00">'+esc(js.error)+'</span>');
        } else if (!js || (!js.text && !js.hints)){
          row('<span style="color:#b00">Sorry, something went wrong.</span>');
        }
      }catch(e){
        row('<span style="color:#b00">Network issue. Try again.</span>');
      }finally{ inFlight=false; }
    }

    async function findSimilar(){
      if (!guard()) return; inFlight=true;
      try{
        var img = (context && context.product && context.product.image) || '';
        if (!img){ row('<span style="color:#b00">No product image found on this page.</span>'); return; }
        var u = new URL(img, location.href);
        if (!u.searchParams.get('width')) u.searchParams.set('width','768');
        row('<em>…searching similar</em>');
        const res = await fetch(API_IMG, {
          method:'POST', headers:{'content-type':'application/json'},
          body: JSON.stringify({ image_url: u.toString(), topK: Number(OPTS.hintLimit||8) })
        });
        const js = await res.json().catch(()=>({}));
        var b=bodyEl(); if (b.lastElementChild) b.lastElementChild.remove();
        if (js && js.ok && Array.isArray(js.hints) && js.hints.length){
          row('<strong>Similar picks</strong>');
          b.insertAdjacentHTML('beforeend','<div class="sa-suggest">'+cards(js.hints)+'</div>');
        } else if (js && js.error === 'budget_exceeded'){
          row('<span style="color:#b00">Daily AI budget reached. Please try again tomorrow.</span>');
        } else {
          row('<span style="color:#b00">Couldn’t find similar from the image.</span>');
        }
      }catch(e){
        row('<span style="color:#b00">Network issue. Try again.</span>');
      }finally{ inFlight=false; }
    }

    document.addEventListener('click',e=>{ if(e.target && e.target.id==='saSend') send(); });
    document.addEventListener('keydown',e=>{ if(e.target && e.target.id==='saInput' && e.key==='Enter') send(); });
    document.addEventListener('click',e=>{ if(e.target && e.target.id==='saSimilarBtn') findSimilar(); });
  }

  // mount
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, {once:true});
  } else {
    mount();
  }
})();
